var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeSpace4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1654,
    height: 50,
    viewBox: "0 0 1654 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1654 0H-1V50H1614L1654 0Z",
    fill: "#E3F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace4);
export default __webpack_public_path__ + "static/media/shape_space_4.7ef2c37faee82a05c82a7e8a1460fa1e.svg";
export { ForwardRef as ReactComponent };